var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 7.3125H15.1875M5.8125 3.5625V2.0625M12.1875 3.5625V2.0625M5.0625 15.1875H12.9375C14.1802 15.1875 15.1875 14.1802 15.1875 12.9375V5.8125C15.1875 4.56986 14.1802 3.5625 12.9375 3.5625H5.0625C3.81986 3.5625 2.8125 4.56986 2.8125 5.8125V12.9375C2.8125 14.1802 3.81986 15.1875 5.0625 15.1875Z",
    stroke: "#FF7926",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOrange);
export default __webpack_public_path__ + "static/media/calendar-orange.f67a684f456ae3f8653419b47199e3ea.svg";
export { ForwardRef as ReactComponent };